import { StoredServiceNote } from "src/app/storage/models/stored-orders/stored-service-note";

/**
 * An instance of the StoredServiceNote model to be used for schema validation
 */
export const storedServiceNoteInstance: StoredServiceNote = {
	Note: "",
	Type: "",
	Timestamp: new Date()
}